import { makeAutoObservable } from 'mobx';
import { getAllUsers, getCurrentUser } from '@tools/ui/api';
import { setAuthHeaders } from '@tools/ui/api';
import { AUTH_TOKEN } from '@tools/ui/consts';
import { User } from '@tools/ui/types';
import { getAuthToken } from '@tools/ui-utils/auth.util';

class UserStore {
  currentUser?: User;

  allUsers?: User[];

  isUserLoggedIn = false;

  constructor() {
    makeAutoObservable(this);
  }

  async fetchCurrentUser(): Promise<void> {
    const user = await getCurrentUser();
    const token = getAuthToken();
    setAuthHeaders(token);
    this.setUser(user);
  }

  setUser(user: User): void {
    this.currentUser = user;
  }

  getCurrentUser(): User | undefined {
    return this.currentUser;
  }

  refreshAllUsers = async (): Promise<void> => {
    const allUsers = await getAllUsers();
    this.setAllUsers(allUsers);
  };

  setAllUsers = (allUsers: User[]): void => {
    this.allUsers = allUsers;
  };

  async signOut(): Promise<void> {
    localStorage.removeItem(AUTH_TOKEN);
    this.currentUser = undefined;
  }

  isCurrentUserAssignedToTask = (curAssignUser: string): boolean => {
    return curAssignUser ? this.currentUser?._id === curAssignUser : false;
  };

  setUserLoggedIn = (loggedIn: boolean): void => {
    this.isUserLoggedIn = loggedIn;
  };

  hasTeamRole = (role: { teamName: string; roleName: string }) => {
    if (!this.currentUser) {
      return false;
    }

    return this.currentUser.roles.some(
      ({ teamId, name }) =>
        name === role.roleName && teamId.name === role.teamName
    );
  };
}

export default new UserStore();
